<section id="why-us" class="clearfix">
  <div class="container">

    <header class="section-header">
      <h1 class="section-title" style="text-align: center;">Quantum Computing</h1>
    </header>

    <div class="row about-container">

      <div class="col-lg-12 content order-lg-1 order-2">
       
        <div class="icon-box wow fadeInUp">
        
          <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Quantum computing uses the phenomenon of quantum mechanics to take a big leap forward in computers to solve some problems. 
            The quantum computer process is different way than classical computers. Generally computers operate on binary bits means in that computers information process is started from zero and ones. But in quantum computers transmit information via quantum bits or qubits, which can exist either one or both simultaneously .</p>
        </div>    

        <div class="icon-box wow fadeInUp">
          <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Quantum computing is an emerging field that has significant potential, especially in the area of optimization problems. 
            Since quantum computing works with different systems than classical computing, the software approach to quantum computing is also different. There are 2 types of quantum software: <b>quantum software</b> for optimization problems and <b>classical computer software</b> that enables quantum computing.  </p>
        </div>    
      
        <div class="icon-box wow fadeInUp">
            
          <h4 class="title"><a href="">There are two types of quantum software </a></h4>
        
        </div>

        <div class="icon-box wow fadeInUp">
            <ul>
              <li><b>	Quantum Algorithms Running Software:  </b>
                <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  Quantum software development kits and computational platforms provide solutions for end users. These help end users develop and test their quantum algorithms.
                </p>
              </li>
              <li><b> Software that enables quantum computers to perform:  </b>
                <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  Random errors cause performance problems in quantum computers, and error-correction software has been developed to correct such errors. Error correction software or firmware is a low-level program.
                </p>
              </li>            
            </ul>
        </div>        
    </div>
    </div>
  </div>

</section>